import { Suspense, lazy, type ComponentType } from "react";
import { createBrowserRouter } from "react-router";
import { NotFoundPage, RouteErrorPage } from "@pmo/shell";
import { LoadingRegion, SkeletonCard } from "@pmo/ui";
import { PortalLayout } from "./PortalLayout";

const Home = lazy(() => import("../features/home/HomePage"));
const Consultations = lazy(() => import("../features/consultations/ConsultationsPage"));
const Consultation = lazy(() => import("../features/consultations/ConsultationDetailPage"));
const Registry = lazy(() => import("../features/registry/RegistryPage"));
const RegistryEntry = lazy(() => import("../features/registry/RegistryDetailPage"));
const Verify = lazy(() => import("../features/verify/VerifyPage"));
const About = lazy(() => import("../features/about/AboutPage"));

const el = (C: ComponentType) => (
  <Suspense
    fallback={
      <LoadingRegion className="min-h-64">
        <SkeletonCard />
      </LoadingRegion>
    }
  >
    <C />
  </Suspense>
);

export const router = createBrowserRouter([
  {
    element: <PortalLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: el(Home) },
      { path: "consultations", element: el(Consultations) },
      { path: "consultations/:slug", element: el(Consultation) },
      { path: "registry", element: el(Registry) },
      { path: "registry/:id", element: el(RegistryEntry) },
      { path: "verify", element: el(Verify) },
      { path: "verify/:number", element: el(Verify) },
      { path: "about", element: el(About) },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
